<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="accountReceivable.id">
                <v-text-field
                  label="Issue No"
                  v-model="accountReceivable.issueNo"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex v-bind="binding">
                <v-text-field
                  label="Customer"
                  v-model="customerName"
                  @click="showCustomers()"
                  :rules="rules.customerIdRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="customerName" mt-4>
                <v-layout row>
                  <v-flex class="ml-3" xs4>
                    <span style="font-weight: bold">Total Advanced Amount</span>
                  </v-flex>
                  <v-flex xs2 style="font-weight: bold">:</v-flex>
                  <v-flex xs4 style="font-weight: bold">
                    {{ totaladvancedAmount | decFormat(6) }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12 v-if="accountReceivable.id">
                <v-autocomplete
                  v-model="accountReceivable.accountReceiveStatus"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="accountReceivable.arType"
                  :items="accountReceivableTypes"
                  color="blue-grey lighten-2"
                  label="Choose Account Receivable Type..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  @change="getTotalCreditAmount(), clearInvoices(), changeOperationType()"
                  :rules="rules.accountReceivableTypeRules"
                ></v-select>
              </v-flex>

              <v-flex :class="isARTypeForReceive() ? 'sm4' : 'sm12'">
                <v-select
                  :items="shopList"
                  label="Select Shop"
                  v-model="accountReceivable.shopId"
                  item-text="name"
                  item-value="id"
                  :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                  @change="getTotalCreditAmount()"
                  :rules="rules.shopRules"
                ></v-select>
              </v-flex>
              <v-flex sm4 v-if="isARTypeForReceive()">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="From Date"
                    type="text"
                    prepend-icon="event"
                    v-model="fromDate"
                    :rules="rules.fromDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="fromDate"
                    @change="getTotalCreditAmount()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm4 v-if="isARTypeForReceive()">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="To Date"
                    type="text"
                    prepend-icon="event"
                    v-model="toDate"
                    :rules="rules.toDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="toDate"
                    @change="getTotalCreditAmount()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="!isAdvanceRepayment()">
                <v-text-field
                  placeholder="Choose Invoice..."
                  v-model="accountReceivable.saleInvoice"
                  @click="showCreditInvoices()"
                  :clearable="true"
                  @click:clear="clearSaleInvoice()"
                  :disabled="isAdvanced() || !isShopAndCustomerSelected()"
                  :rules="getInvoiceNoRules()"
                  
                ></v-text-field>
                <span
                  class="caption , ml-2 , info--text"
                  v-if="!isShopAndCustomerSelected()"
                  >Choose Shop and Customer First
                </span>
              </v-flex>
              <v-flex :class="isAdvanceRepayment() ? 'sm12' : 'sm6'">
                <v-text-field
                  label="Choose Advanced Invoice"
                  clearable
                  @click:clear="clearAdvanceNo"
                  @click="showAdvancedARListDialog = !showAdvancedARListDialog"
                  v-model="accountReceivable.advancedIssueNo"
                  :disabled="
                    isAdvanced() ||
                    !isShopAndCustomerSelected() ||
                    isAdvanceIssueNoDisabled()
                  "
                  :rules="getInvoiceNoRules()"

                ></v-text-field>
              </v-flex>

              <v-flex sm12 v-if="isOperationSetting()">
                <v-select
                  :items="operationSettingList"
                  label="Operation Setting"
                  v-model="accountReceivable.operationSettingId"
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  :rules="rules.required('Operation Setting')"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="!isARTypeForReceive()">
                <v-text-field
                  name="cashAmount"
                  label="Cash Amount"
                  v-model="accountReceivable.cashAmount"
                  :rules="rules.cashAmountRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!isARTypeForReceive()">
                <v-text-field
                  name="chequeNo"
                  label="Cheque No"
                  v-model="accountReceivable.chequeNo"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!isARTypeForReceive()">
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="accountReceivable.remark"
                  type="text"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
              <v-layout row wrap class="pa-3" v-if="isARTypeForReceive()">
                <v-flex sm8>
                  <v-flex sm12>
                    <v-text-field
                      name="cashAmount"
                      label="Cash Amount"
                      v-model="accountReceivable.cashAmount"
                      :rules="rules.cashAmountRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm12>
                    <v-text-field
                      name="remark"
                      label="Remark"
                      v-model="accountReceivable.remark"
                      type="text"
                      :rules="rules.remarkRules"
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex sm4 mt-4>
                  <v-card mt-4 style="card-border: 1px solid #dde6f3">
                    <v-card-text class="font-weight-bold">
                      <span>Total Credit Amount</span>
                      <span class="ml-5"
                        >:
                        {{ totalCreditAmount | decFormat(6) }}</span
                      >
                    </v-card-text>
                    <v-card-text class="font-weight-bold">
                      <span>Total Remaining Amount</span>
                      <span class="ml-3"
                        >:
                        {{
                          totalRemainingAmount | decFormat(6)
                        }}</span
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-flex sm12 v-if="accountReceivable.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="accountReceivable.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="accountReceivable.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="accountReceivable.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="accountReceivable.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || status != 'DRAFT' || saveLoading"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Invoice list dialog -->
    <v-dialog v-model="showInvoiceListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="invoiceQueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="invoiceQueryParams.fromDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="invoiceQueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="invoiceQueryParams.toDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="saleTypeList"
                label="Sale Type"
                item-text="label"
                item-value="value"
                v-model="invoiceQueryParams.saleType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="invoiceNo"
                label="Invoice No"
                type="text"
                class="mr-1"
                v-model="invoiceQueryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                class="mr-1"
                v-model="invoiceQueryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchInvoice">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card>
            <v-card-title class="blue darken-3">
              <span class="headline white--text">Summary</span>
            </v-card-title>
            <v-card-text class="font-weight-bold">
              <div>
                <span>Total Net Amount:</span>
                <v-chip>
                  <span>{{ totalNetAmount | numFormat }}</span>
                </v-chip>
              </div>
              <!-- <div>
                <span>Total Paid Amount:</span>
                <v-chip>
                  <span>{{ totalCreditPaidAmount | numFormat}}</span>
                </v-chip>
              </div>-->
              <div>
                <span>Total Remaining Amount:</span>
                <v-chip>
                  <span>{{ totalRemainingAmount | numFormat }}</span>
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
          <!-- Invoice List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="invoiceListHeaders"
                :items="creditInvoiceList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="invoiceTotalRows"
                :rows-per-page-items="rowsPerPageItems3"
                :pagination.sync="invoicePagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setInvoice(
                        props.item.invoiceNo,
                        props.item.netAmount,
                        props.item.remainingAmount
                      ),
                        (showInvoiceListDialog = !showInvoiceListDialog)
                    "
                  >
                    <a>{{ props.item.invoiceNo }}</a>
                  </td>
                  <td>
                    {{
                      props.item.createdDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.netAmount | numFormat }}</td>
                  <td>{{ props.item.creditPaidAmount | numFormat }}</td>
                  <td>{{ props.item.remainingAmount | numFormat }}</td>
                  <td>{{ props.item.saleType }}</td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="queryParams.email"
              ></v-text-field>
            </v-flex>

            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="activeCustomerList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setCustomer(
                        props.item.name,
                        props.item.id,
                        props.item.advancedAmount
                      ),
                        (showCustomerListDialog = !showCustomerListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--advanced issue no-->
    <AdvancedAccountReceivableDialog
      :showAdvancedARListDialog="showAdvancedARListDialog"
      :fromDate="fromDate"
      :toDate="toDate"
      :customerId="accountReceivable.customerId"
      :shopId="accountReceivable.shopId"
      @changeAccountReceivable="changeAccountReceivable($event)"
    ></AdvancedAccountReceivableDialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { AccountReceivable } from "../../models/model";
import { customerService } from "../../services/customer-service";
import { operationSettingService } from "../../services/operation-setting-service";
import { shopService } from "../../services/shop-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { creditLevelService } from "../../services/credit-level-service";
import { AccountReceivableFormRules } from "../../helpers/validation-rules";
import { accountReceivableService } from "../../services/account-receivable-service";
import { customerCreditBalanceService } from "../../services/customer-credit-balance-service";
import AdvancedAccountReceivableDialog from "./AdvancedAccountReceivableDialog.vue";

export default {
  name: "AccountReceivableDetail",
  components: { VSwitch, AdvancedAccountReceivableDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Account Receivable",
        disabled: false,
        to: "accountreceivables",
      },
      {
        text: "Account Receivable Detail",
        disabled: true,
      },
    ],
    accountReceivableTypes: [
      { label: "Advanced", value: "ADVANCED" },
      { label: "Advance Repayment", value: "ADVANCE_REPAYMENT" },
      { label: "Credit Receive", value: "CREDIT_RECEIVE" },
      // { label: "TGI Credit Receive", value: "TGI_CREDIT_RECEIVE" },
      { label: "Advance Credit Receive", value: "ADVANCE_CREDIT_RECEIVE" },
      { label: "Discount", value: "DISCOUNT" },
      // { label: "Damage", value: "DAMAGE" },
      // { label: "Delivery", value: "DELIVERY" },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    status: "DRAFT",
    createdDate: "",
    updatedDate: "",
    decimalFormat: "",
    totaladvancedAmount: 0,
    fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    responseError: "",
    saveLoading: false,
    activeCustomerList: [],
    customerList: [],
    creditLevelList: [],
    tempList: [],
    shopList: [],
    totalCreditAmount: 0,
    totalRemainingAmount: 0,
    rules: new AccountReceivableFormRules(),
    accountReceivable: new AccountReceivable(),
    oldaccountReceivable: new AccountReceivable(),
    messageDialogBox: false,
    showCustomerListDialog: false,
    showAdvancedARListDialog: false,
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    invoiceListHeaders: [
      { text: "Invoice No", value: "invoiceNo", sortable: false },
      { text: "Issue Date", value: "createdDate", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
      { text: "Paid Amount", value: "creditPaidAmount", sortable: false },
      { text: "Remaining Amount", value: "remainingAmount", sortable: false },
      { text: "Sale Type", value: "saleType", sortable: false },
      { text: "Description", value: "description", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    rowsPerPageItems3: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      email: "",
    },
    showListLoading: false,
    customerName: "",
    priceModelName: "",

    showInvoiceListDialog: false,
    invoiceQueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      saleType: "",
      customerId: "",
      shopId: "",
      status: "CREDIT",
      description: "",
    },
    invoicePagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
    saleTypeList: [
      { label: "----All----", value: "" },
      { label: "RETAIL", value: "RETAIL" },
      { label: "WHOLE_SALE", value: "WHOLE_SALE" },
    ],
    creditInvoiceList: [],
    operationSettingList: [],
    type: "",
    invoiceTotalRows: 0,
    totalNetAmount: 0,
    totalCreditPaidAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },
  computed: {
    binding() {
      var binding = {};
      if (this.customerName) {
        binding.sm6 = true;
      } else binding.sm12 = true;
      return binding;
    },
  },
  created() {
    //this.getActiveCustomer();
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.accountReceivable.shopId = this.user.shopId;
    }
    const id = this.$route.params.id;
    if (id == "new") {
      // new Customer
    } else {
      this.getAccountReceivableDetail(id);
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },

  methods: {
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAccountReceivableDetail(id) {
      accountReceivableService.getAccountReceivableDetail(id).then((res) => {
        this.accountReceivable = res.data;
        this.status = this.accountReceivable.accountReceiveStatus;
        this.customerList = [res.data.customer];
        this.createdDate = commonService.formatDate(
          new Date(this.accountReceivable.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.accountReceivable.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.issueDate = commonService.millisecondToDate(
          this.accountReceivable.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        if (this.isARTypeForReceive()) {
          this.fromDate = commonService.millisecondToDate(
            this.accountReceivable.fromDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.toDate = commonService.millisecondToDate(
            this.accountReceivable.toDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.getTotalCreditAmount();
        }
        this.changeOperationType();
        this.oldaccountReceivable = Object.assign({}, res.data);
        let cust = commonService.search(
          "id",
          this.accountReceivable.customerId,
          this.customerList
        );
        this.customerName = cust.name;
        this.totaladvancedAmount = cust.advancedAmount;
      });
    },

    onSearchInvoice() {
      this.invoiceQueryParams.page = this.invoicePagination.page;
      this.invoiceQueryParams.size = this.invoicePagination.rowsPerPage;
      this.getCreditInvoiceList();
      this.getCreditInvoiceSummary();
    },
    showCreditInvoices() {
      // Clear search query params
      this.invoiceQueryParams.fromDate = this.fromDate;
      this.invoiceQueryParams.toDate = this.toDate;
      this.invoiceQueryParams.invoiceNo = "";
      this.invoiceQueryParams.status = "CREDIT";
      this.invoiceQueryParams.saleType = "";
      this.invoiceQueryParams.shopId = this.accountReceivable.shopId;
      this.invoiceQueryParams.customerId = this.accountReceivable.customerId;
      this.invoiceQueryParams.description = "";
      this.getCreditInvoiceSummary();
      this.getCreditInvoiceList().then(
        (this.showInvoiceListDialog = !this.showInvoiceListDialog)
      );
    },

    getCreditInvoiceList() {
      this.showListLoading = true;
      return customerCreditBalanceService
        .getCustomerCreditBalance(
          this.invoiceQueryParams,
          this.invoicePagination.page,
          this.invoicePagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this.creditInvoiceList = res.data.customerCreditBalanceList;
            this.invoiceTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCreditInvoiceSummary() {
      customerCreditBalanceService
        .getCustomerCreditBalanceSummary(this.invoiceQueryParams)
        .then((res) => {
          if (res.data) {
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setInvoice(invoiceNo, netAmount, remainingAmount) {
      this.accountReceivable.saleInvoice = invoiceNo;
      this.totalRemainingAmount = remainingAmount;
      this.totalCreditAmount = netAmount;
      this.fromDate = this.invoiceQueryParams.fromDate;
      this.toDate = this.invoiceQueryParams.toDate;
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.accountReceivable.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          if (this.isARTypeForReceive()) {
            this.accountReceivable.fromDateInMilliSeconds =
              commonService.convertToMilliseconds(this.fromDate);
            this.accountReceivable.toDateInMilliSeconds =
              commonService.convertToMilliseconds(this.toDate);
          }
          accountReceivableService
            .saveAccountReceivable(this.accountReceivable)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.accountReceivable.id) {
        this.customerName = "";
        this.fromDate = commonService.formatDate(new Date(), "YYYY-MM-DD");
        (this.toDate = commonService.formatDate(new Date(), "YYYY-MM-DD")),
          (this.totalCreditAmount = 0);
        this.totalRemainingAmount = 0;
        this.totaladvancedAmount = 0;
        this.accountReceivable = new AccountReceivable();
      } else {
        this.accountReceivable = Object.assign({}, this.oldaccountReceivable);
        let cust = commonService.search(
          "id",
          this.accountReceivable.customerId,
          this.customerList
        );
        this.customerName = cust.name;
        this.totaladvancedAmount = cust.advancedAmount;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getActiveCustomer();
    },
    showCustomers() {
      this.getCreditLevels();
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.email = "";

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getTotalCreditAmount() {
      if (
        this.isARTypeForReceive() &&
        this.accountReceivable.customerId != "" &&
        this.accountReceivable.shopId
      ) {
        accountReceivableService
          .getCreditAmountAndRemainingAmount(
            this.fromDate,
            this.toDate,
            this.accountReceivable.customerId,
            this.accountReceivable.shopId,
            this.accountReceivable.saleInvoice
          )
          .then((res) => {
            this.totalCreditAmount = res.data.totalCreditAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          });
      }
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setCustomer(name, id, advancedAmount) {
      this.accountReceivable.customerId = id;
      this.customerName = name;
      this.totaladvancedAmount = advancedAmount;
      this.getTotalCreditAmount();
    },
    clearSaleInvoice() {
      this.accountReceivable.saleInvoice = "";
      this.getTotalCreditAmount();
    },
    clearAdvanceNo() {
      this.accountReceivable.advancedIssueNo = "";
      this.accountReceivable.cashAmount = 0;
    },
    changeAccountReceivable(ar) {
      this.accountReceivable.advancedIssueNo = ar.issueNo;
      this.accountReceivable.cashAmount = ar.remainingAmount;
      this.showAdvancedARListDialog = !this.showAdvancedARListDialog;
    },
    clearInvoices() {
      if (this.isAdvanced()) {
        this.accountReceivable.saleInvoice = null;
        this.accountReceivable.advancedIssueNo = null;
      } else if (this.isAdvanceRepayment()) {
        this.accountReceivable.saleInvoice = null;
      }
      if (this.isAdvanceIssueNoDisabled()) {
        this.accountReceivable.advancedIssueNo = null;
      }
    },

    isAdvanced() {
      return this.accountReceivable.arType == "ADVANCED";
    },
    isAdvanceRepayment() {
      return this.accountReceivable.arType == "ADVANCE_REPAYMENT";
    },
    isARTypeForReceive() {
      return (
        this.accountReceivable.arType == "CREDIT_RECEIVE" ||
        this.accountReceivable.arType == "TGI_CREDIT_RECEIVE" ||
        this.accountReceivable.arType == "ADVANCE_CREDIT_RECEIVE" ||
        this.accountReceivable.arType == "DISCOUNT" ||
        this.accountReceivable.arType == "DAMAGE" ||
        this.accountReceivable.arType == "DELIVERY"
      );
    },
    isOperationSetting(){
      return(
        this.accountReceivable.arType == "ADVANCED" ||
        this.accountReceivable.arType == "ADVANCE_REPAYMENT" ||
        this.accountReceivable.arType == "CREDIT_RECEIVE"
      );
    },
    isAdvanceIssueNoDisabled() {
      return (
        this.accountReceivable.arType == "CREDIT_RECEIVE" ||
        this.accountReceivable.arType == "TGI_CREDIT_RECEIVE" ||
        this.accountReceivable.arType == "DISCOUNT" ||
        this.accountReceivable.arType == "DAMAGE" ||
        this.accountReceivable.arType == "DELIVERY"
      );
    },
    isAdvanceCreditReceive() {
      return this.accountReceivable.arType == "ADVANCE_CREDIT_RECEIVE";
    },

    isShopAndCustomerSelected() {
      return this.accountReceivable.shopId && this.accountReceivable.customerId;
    },

    getInvoiceNoRules() {
      let rules = this.rules.invoiceNoRules;
      let required = this.isAdvanceCreditReceive() || this.isAdvanceRepayment();
      return required && this.isShopAndCustomerSelected() ? rules : [];
    },
    
    changeOperationType(){
      if(this.accountReceivable.arType == "ADVANCED"){
        this.type = "ADVANCED";
        this.getOperationSettingList()
      }else if(this.accountReceivable.arType == "ADVANCE_REPAYMENT"){
        this.type = "CUSTOMER_ADVANCE_REPAYMENT";
        this.getOperationSettingList()
      }else if(this.accountReceivable.arType == "CREDIT_RECEIVE"){
        this.type = "CREDIT_RECEIVED";
        this.getOperationSettingList()
      }else {
        this.accountReceivable.operationSettingId = null;
      }
    },
    getOperationSettingList() {
      operationSettingService
        .getOperationSettingListByType(this.type)
        .then((res) => {
          this.operationSettingList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
